/**Nhap danh muc chu tau */
import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  OutlinedInput,
  InputBase,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
} from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import SelectFilter from "react-select";

/*----------------------Cac control trong project su dung den trong form----------------*/
import {
  filterStyles,
  formStyles,
  loadDataError,
  handleServerError,
  ReactDataGrid_i18n,
  showError,
} from "../components/common";
import SimpleDialog from "../components/SimpleDialog";
import MyNumberEditor from "../components/MyNumberEditor";
import MyDateEditor from "../components/MyDateEditor";
import MyDateTimeEditor from "../components/MyDateTimeEditor";

/*-----------------------Cac thu vien dung chung -------------------------*/
const myLib = require("../lib/MyLib");
const server = require("../lib/server");
const dataStruct = require("../data/DataStruct");
/*-----------------------Cac dinh nghia ----------------------------------*/
const englishUI = true;

/*-----------------------Dinh nghia cac label tieng Anh, tieng Viet su dung trong form*/
const formTitle = englishUI ? "Revised Consumption" : "Hiệu chỉnh mức tiêu thụ";
const fieldLabels = englishUI
  ? {
      TripCode: "Trip code:",
      ReportDataTime: "Report time:",
      HCRobFO: "Cons - FO",
      HCRobDO: "Cons - DO",
      HCRobCyl: "Cons - Cyl",
      HCRobSys: "Cons - Sys",
      HCRobAE: "Cons - AE",
      HCRobHyd: "Cons - Hyd",
    }
  : {
      TripCode: "Trip code:",
      ReportDataTime: "Report time:",
      HCRobFO: "Cons - FO",
      HCRobDO: "Cons - DO",
      HCRobCyl: "Cons - Cyl",
      HCRobSys: "Cons - Sys",
      HCRobAE: "Cons - AE",
      HCRobHyd: "Cons - Hyd",
    };
const buttonLabels = englishUI
  ? {
      btnSave: "Save",
      btnClose: "Close",
    }
  : {
      btnSave: "Lưu",
      btnClose: "Thoát",
    };

function validate_Data(data) {
  var ret = myLib.validateEmpty(data, ["TripCode"]);
  if (Object.keys(ret).length == 0) {
    //ko co loi thi kiem tra cac dieu kien khac
  }

  ret.error = Object.keys(ret).length > 0;
  ret.GUID = new Date(); //danh dau version

  return ret;
}
////////////////////////--------------/////////////////////////////////////////
export default class RevisedRobDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validateStatus: { error: false }, //trang thai validate
      DanhMuc: props.DanhMuc,
      after: {
        HCRobFO: null,
        HCRobDO: null,
        HCRobCyl: null,
        HCRobSys: null,
        HCRobAE: null,
        HCRobHyd: null,
        ...(props.edittingRecord ? props.edittingRecord : {}),
      },
    };
  }

  componentDidMount() {
    this.loadDanhMuc();
  }
  //load du lieu khi form load
  loadDanhMuc() {
    //lay ma chuyen tu dong tiep theo
    if (this.props.edittingRecord != undefined) {
      this.setState({ saving: true });
      server
        .post("Data/DoRequest", {
          Function: "Proc_DR_TempReport_GetHieuChinh",
          ThamSo: {
            ReportID: this.props.edittingRecord.ReportID,
          },
        })
        .then((response) => {
          //du lieu cua 1 do thi
          let list = response.DR_TempReport;
          this.setState({
            saving: false,
            after:
              list.length > 0
                ? { ...this.state.after, ...list[0] }
                : this.state.after,
          });
        })
        .catch((error) => {
          handleServerError(error);
          this.setState({ saving: false });
        });
    }
  }
  //call khi user thay doi trang
  static getDerivedStateFromProps(nextProps, prevState) {
    return { open: nextProps.open };
  }
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = { after: { ...this.state.after } }; //new value
    s.after[fieldName] = value;
    s.dataChanged = true;
    this.setState(s);
  };
  saveData = (obj) => {
    var old_changed = this.state.dataChanged;
    var s = {};
    s.dataChanged = true;
    s.canSaved = s.dataChanged;
    s.after = { ...this.state.after, ...obj };
    this.setState(s);
  };
  doSave = () => {
    try {
      var data = this.state.after;
      var check = validate_Data(this.state.after);
      //chuyen doi format

      var action = this.props.edittingRecord ? "update" : "insert";
      if (!check.error) {
        this.setState({ validateStatus: check, saving: true, errorLog: "" });
        server
          .post("Data/DoRequest", {
            Function: "Proc_DR_DailyReport_UpdateHieuChinh",
            ThamSo: data,
          })
          .then((response) => {
            this.setState({
              dataChanged: false,
              canSaved: false,
              saving: false,
              errorMessage: "",
              errorLog: "",
            });
            //thong bao cho parent biet co data duoc saved
            if (this.props.onSaved) {
              this.props.onSaved(action, data);
            }
            alert("Cập nhật thành công!");
            this.props.close(data);
          })
          .catch((error) => {
            handleServerError(error);
            this.setState({ saving: false });
          });
      } else {
        this.setState({ validateStatus: check });
        showError("Vui lòng kiểm tra các trường đánh dấu đỏ!");
      }
    } catch (ex) {
      showError(ex);
    }
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        maxWidth={"sm"}
        fullWidth={true}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{formTitle}</DialogTitle>
        <DialogContent>
          <div
            style={{
              minWidth: 500,
              minHeight: 30,
              padding: 5,
              fontSize: 10,
              wordWrap: "break-word",
            }}
          >
            <Grid container spacing={1} columns={24}>
              <Grid item xs={8}>
                <FormLabel>{fieldLabels.TripCode}</FormLabel>
              </Grid>
              <Grid item xs={16}>
                <OutlinedInput
                  id="TripCode"
                  fullWidth
                  readOnly={true}
                  inputProps={{
                    style: { textTransform: "uppercase" },

                    maxLength: 20,
                  }}
                  value={this.state.after.TripCode}
                  onChange={(event) => {
                    this.saveField(
                      "TripCode",
                      myLib.toUpperCase(event.target.value)
                    );
                  }}
                  error={this.state.validateStatus.TripCode !== undefined}
                />
              </Grid>
              <Grid item xs={8}>
                <FormLabel>{fieldLabels.ReportDataTime}</FormLabel>
              </Grid>
              <Grid item xs={8}>
                <MyDateTimeEditor
                  id="ReportDataTime"
                  key="ReportDataTime"
                  fullWidth
                  readOnly
                  value={this.state.after.ReportDataTime}
                  onChange={(value) => {
                    this.saveField("ReportDataTime", value);
                  }}
                  error={this.state.validateStatus.ReportDataTime !== undefined}
                />
              </Grid>
              <Grid item xs={8}></Grid>
              <Grid item xs={8}>
                <FormLabel>{fieldLabels.HCRobFO}</FormLabel>
              </Grid>
              <Grid item xs={8}>
                <MyNumberEditor
                  id="HCRobFO"
                  key="HCRobFO"
                  fullWidth
                  autoFocus
                  value={this.state.after.HCRobFO}
                  onChange={(value) => {
                    this.saveField("HCRobFO", value);
                  }}
                  error={this.state.validateStatus.HCRobFO !== undefined}
                />
              </Grid>
              <Grid item xs={8}></Grid>
              <Grid item xs={8}>
                <FormLabel>{fieldLabels.HCRobDO}</FormLabel>
              </Grid>
              <Grid item xs={8}>
                <MyNumberEditor
                  id="HCRobDO"
                  key="HCRobDO"
                  fullWidth
                  value={this.state.after.HCRobDO}
                  onChange={(value) => {
                    this.saveField("HCRobDO", value);
                  }}
                  error={this.state.validateStatus.HCRobDO !== undefined}
                />
              </Grid>
              <Grid item xs={8}></Grid>
              <Grid item xs={8}>
                <FormLabel>{fieldLabels.HCRobCyl}</FormLabel>
              </Grid>
              <Grid item xs={8}>
                <MyNumberEditor
                  id="HCRobCyl"
                  key="HCRobCyl"
                  fullWidth
                  value={this.state.after.HCRobCyl}
                  onChange={(value) => {
                    this.saveField("HCRobCyl", value);
                  }}
                  error={this.state.validateStatus.HCRobCyl !== undefined}
                />
              </Grid>
              <Grid item xs={8}></Grid>
              <Grid item xs={8}>
                <FormLabel>{fieldLabels.HCRobSys}</FormLabel>
              </Grid>
              <Grid item xs={8}>
                <MyNumberEditor
                  id="HCRobSys"
                  key="HCRobSys"
                  fullWidth
                  value={this.state.after.HCRobSys}
                  onChange={(value) => {
                    this.saveField("HCRobSys", value);
                  }}
                  error={this.state.validateStatus.HCRobSys !== undefined}
                />
              </Grid>
              <Grid item xs={8}></Grid>
              <Grid item xs={8}>
                <FormLabel>{fieldLabels.HCRobAE}</FormLabel>
              </Grid>
              <Grid item xs={8}>
                <MyNumberEditor
                  id="HCRobAE"
                  key="HCRobAE"
                  fullWidth
                  value={this.state.after.HCRobAE}
                  onChange={(value) => {
                    this.saveField("HCRobAE", value);
                  }}
                  error={this.state.validateStatus.HCRobAE !== undefined}
                />
              </Grid>
              <Grid item xs={8}></Grid>
              <Grid item xs={8}>
                <FormLabel>{fieldLabels.HCRobHyd}</FormLabel>
              </Grid>
              <Grid item xs={8}>
                <MyNumberEditor
                  id="HCRobHyd"
                  key="HCRobHyd"
                  fullWidth
                  value={this.state.after.HCRobHyd}
                  onChange={(value) => {
                    this.saveField("HCRobHyd", value);
                  }}
                  error={this.state.validateStatus.HCRobHyd !== undefined}
                />
              </Grid>
              <Grid item xs={8}></Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.doSave();
            }}
            variant="contained"
            disabled={this.state.saving}
          >
            {buttonLabels.btnSave}
          </Button>

          <Button
            onClick={() => {
              if (this.props.close) {
                this.props.close(false);
              }
            }}
            disabled={this.state.saving}
            variant="contained"
          >
            {buttonLabels.btnClose}
          </Button>
        </DialogActions>
        
      </Dialog>
    );
  }
}
